module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-styled-components@6.2.0_ixlgvrpzf7mze2aagjzkpzvkpm/node_modules/gatsby-plugin-styled-components/gatsby-browser.js'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false,"disableVendorPrefixes":false},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.2.0_fr34benm3kujjwytbr2cydeh4i/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
